import styles from './styles.module.scss'

export function LoginButton(props) {
  const { buttonText, onClick } = props

  return (
    <div className={styles.buttonWrapper}>
      <button 
        className={styles.button}
        onClick={onClick}
      >
        <span>{buttonText}</span>
      </button>
    </div>
  )
}